import React, { useContext } from 'react'
import { LiabilitiesContext } from '../context'
import { Index } from './Index/index'
import { Create } from './Create/index'
import { Form } from './Form/index'
import { Destroy } from './Destroy/index'

export const Screens = () => {
  const { state } = useContext(LiabilitiesContext)
  const { screen } = state
  const showingIndex = screen === 'index' || screen === 'destroy'
  return (
    <>
      {showingIndex && <Index />}
      {screen === 'create' && <Create />}
      {screen === 'form' && <Form />}
      {screen === 'destroy' && <Destroy />}
    </>
  )
}
